/* eslint-disable no-multi-str */
import React from 'react'
import {
  FormDashboardInput as Input,
  FormDashboardLabel as Label,
  FormRow,
} from '../../../components'
// import 'tinymce'
// Default icons are required for TinyMCE 5.3 or above
// import 'tinymce/icons/default'
// A theme is also required
// import 'tinymce/themes/silver'
// import 'tinymce/plugins'
import { Editor } from '@tinymce/tinymce-react'

const Form = () => {
  const [loading, setLoading] = React.useState(true)
  const handleEditorChange = (e) => {
    console.log(e)
  }

  return (
    <form>
      <div className="lg:hidden">
        <div className="mobile-fullwidth">
          <div className="p-6 rounded mb-8" style={{background: '#f5f5f5'}}>
            <p className="text-sm text-gray-444 text-center">
              Status: <strong>Published</strong>
            </p>
          </div>
        </div>
      </div>
      <p className="text-lg font-bold mb-5 lg:mb-8">Title</p>
      <FormRow>
        <Label>Title (English)</Label>
        <Input className="w-full" defaultValue="Excercitation Veniam Consequat 1442H"/>
      </FormRow>
      <FormRow last>
        <Label>Title (Indonesia)</Label>
        <Input className="w-full" defaultValue="Distribusi Sedekah Ramadhan 1442H"/>
      </FormRow>

      <hr className="mb-8"/>

      <p className="text-lg font-bold mb-5 lg:mb-8">Content</p>
      <div className="mb-5 lg:mb-8">
        {
          loading &&
          <div>loading editor...</div>
        }
        <div className="mb-5 lg:mb-8">
          {
            !loading &&
            <Label>Content (English)</Label>
          }
          <Editor
            apiKey="p92e8neygbpdv4yznm7pvlowzukov64286chr8rkq5td7s1z"
            initialValue="<p>This is the initial content of the editor</p>"
            init={{
              height: 500,
              menubar: false,
              plugins: [
                'advlist autolink lists link image charmap print preview anchor',
                'searchreplace visualblocks code fullscreen',
                'insertdatetime media table paste code help wordcount'
              ],
              toolbar:
                'undo redo | formatselect | bold italic backcolor image link | \
                alignleft aligncenter alignright alignjustify | \
                bullist numlist outdent indent | removeformat | help'
            }}
            onEditorChange={handleEditorChange}
            onInit={() => setLoading(false)}
          />
        </div>
        <div className="mb-5 lg:mb-8">
          {
            !loading &&
            <Label>Content (Indonesia)</Label>
          }
          <Editor
            apiKey="p92e8neygbpdv4yznm7pvlowzukov64286chr8rkq5td7s1z"
            initialValue="<p>This is the initial content of the editor</p>"
            init={{
              height: 500,
              menubar: false,
              plugins: [
                'advlist autolink lists link image charmap print preview anchor',
                'searchreplace visualblocks code fullscreen',
                'insertdatetime media table paste code help wordcount'
              ],
              toolbar:
                'undo redo | formatselect | bold italic backcolor image link | \
                alignleft aligncenter alignright alignjustify | \
                bullist numlist outdent indent | removeformat | help'
            }}
            onEditorChange={handleEditorChange}
            onInit={() => setLoading(false)}
          />
        </div>
      </div>
    </form>
  )
}

export { Form }